import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import queryString from 'query-string';
import DOMPurify from 'dompurify';
import jwtDecode from 'jwt-decode';
import { validateEmailChangeToken } from '../../../api/email';

const getToken = () => {
  const urlParams = queryString.parse(globalThis.location.search);
  return DOMPurify.sanitize(urlParams.token as string);
}

export const useTokenData = () => {
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(true);
  const [isValid, setIsValid] = useState(true);
  const [token, setToken] = useState('');
  const [oldEmail, setOldEmail] = useState('');
  const [newEmail, setNewEmail] = useState('');

  useEffect(() => {
    const validateTokenAndParseUserInfo = async () => {
      try {
        const token = getToken();
        if (!token) {
          navigate('/error?error_description=Invalid query params', { replace: true });
          return;
        }

        const isTokenValid = await validateEmailChangeToken(token);
        if (!isTokenValid) {
          setIsValid(false);
          return;
        }

        const decodedToken = jwtDecode<{ current_email: string, new_email: string }>(token);

        setToken(token);
        setOldEmail(decodedToken.current_email);
        setNewEmail(decodedToken.new_email);
      }
      catch (error) {
        console.error('Error validating token:', error);
        navigate('/error?error_description=Error fetching data', { replace: true });
      }
      finally {
        setIsLoading(false);
      }
    }

    validateTokenAndParseUserInfo();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { isLoading, isValid, oldEmail, newEmail, token };
}
